import { Component, input } from '@angular/core';
import { ScorecardMode } from '../scorecard/scorecard.component';

@Component({
  selector: 'app-scorecard-legend',
  imports: [],
  templateUrl: './scorecard-legend.component.html',
  styleUrl: './scorecard-legend.component.scss',
})
export class ScorecardLegendComponent {
  currentMode = input<ScorecardMode>('scores');
}
